export default __webpack_public_path__ + "static/media/hero-prakerja.c123e51c.png";